window.HelpPopup = LayerPopup.extend({
    initialize: function(url) {
        this.name = "HelpPopup";

        this.url = url;
        this.questionPopup = undefined;
        this.currentData = {
            title: "Sample",
            content: "Sample content...",
            buttons: {
                okay: "OK sir"
            }
        };

        LayerPopup.prototype.initialize.call(this, url);

        this.listenTo(this, "onContentMatched", this.handleContentMatched);
    },

    setup: function(container) {
        LayerPopup.prototype.setup.call(this, container);

        var $button = this.$el.find(".ok-button");
        $button.text(LanguageManager.getString("close"));

        var button = new Button({
            el: $button,
            isAnimated: true
        });
        this.listenTo(button, "onClick", this.handleOKClicked);
    },

    handleOnChangeSlide: function(e) {
        LayerPopup.prototype.handleOnChangeSlide.call(this, e);
        this.hidePopupWindow();
    },

    handleOnJunctionUpdate: function(e) {
        LayerPopup.prototype.handleOnJunctionUpdate.call(this, e);
        this.hidePopupWindow();
    },

    isPageComplete: function(pageData) {
        return false; // We need to update help content always even if current page is completed
    },

    getDom: function() {
        return $(Handlebars.templates["popup/helppopup"]());
    },

    handleContentMatched: function(e) {
        var xmlLoader = new AssetLoader({
            name: this.name
        });
        xmlLoader.addXML(this.expertXmlUrl);

        this.listenTo(xmlLoader, "onAssetLoaded", this.handleContentLoaded);
        xmlLoader.start();
    },

    handleContentLoaded: function(e) {
        var $xml = $(e.resource.getXML());

        var title = $xml.find("mainText").find("title").text();
        var content = $xml.find("mainText").find("text").text();

        this.currentData = {
            title: title,
            content: content,
            buttons: {
                okay: ""
            }
        };

        this.checkExpertAndHelpOverlapping();
    },

    handleOKClicked: function() {
        this.hidePopupWindow();
    },

    checkForContent: function(eventName, pageData) {
        var contentMatch = false;
        for (var i = 0; i < this.layerData.length; i++) {
            var id = this.layerData[i].id;
            var expertEventTrigger = this.layerData[i].eventName;
            if (id == pageData.pageID()) { // removed eventName match as the help is reuired always
                this.isExpertOpen = true;
                contentMatch = true;

                this.clearPreviousContent();
                this.expertXmlUrl = this.layerData[i].xml;

                this.trigger("onContentMatched", {
                    pageID: id,
                    xmlUrl: this.layerData[i].xml,
                    eventName: eventName,
                    isMandatory: this.layerData[i].isMandatory
                });
            }
        }

        if (!contentMatch) {
            this.trigger("onNoContentMatched");

            this.hidePopupWindow();
        }
    },

    showPopupWindow: function() {
        var self = this;
        var pageData = this.container.session.currentPageData;

        var isInJunction = this.container.router.isInJunction(pageData.pageID());

        if (isInJunction) {
            pageData = this.container.session.currentPageData.getBlock(0).view.gameController.currentPageData;
        }

        //this.checkForContent('Page.onStarted', pageData);

        this.checkExpertAndHelpOverlapping();

        if (this.questionPopup === undefined) {
            this.questionPopup = new AccessibleBootbox({
                title: this.currentData.title,
                message: this.currentData.content,
                className: "help-popup",
                // onEscape: false, // TODO: this swicth is not working in the AccessibleBootbox.js
                animate: true, // must not be animated as popin complete not triggered correctly in IE9
                buttons: {
                    okay: {
                        label: LanguageManager.getString("close"),
                        className: "btn-primary",
                        callback: function() {
                            if (self.questionPopup !== undefined) {
                                self.questionPopup.destroy();
                            }
                            self.questionPopup = undefined;
                        }
                    }

                }
            });

            this.questionPopup.popIn();
        }
    },

    checkExpertAndHelpOverlapping: function() {
        if (LayerPopup.prototype.isExpertOpen) {
            this.actualHelpText = this.$modalBody.html();
            this.isExpertOverlappedWithHelp = true;
            this.$modalBody.html(LanguageManager.getString('expert_help_text'));
        }
    },

    hidePopupWindow: function() {
        if (this.isExpertOverlappedWithHelp) {
            this.isExpertOverlappedWithHelp = false;
            this.$modalBody.html(this.actualHelpText);
        }

        if (this.questionPopup) {
            this.questionPopup.popOut();
            this.questionPopup.destroy();
            this.questionPopup = undefined;
        }

        this.isOpen = false;

        this.trigger("onHide", {
            target: this
        });
    },

    getShowPosition: function() {
        return false;
    },

    getHidePosition: function() {
        return false;
    }
});
